import React, { Component, PropTypes } from 'react';
import { reduxForm, Field, SubmissionError } from 'redux-form';
import first from 'lodash/first';
import Money from 'common/components/money';
import ModalDialog from 'common/components/modal/modal_dialog';
import AnimatedButton from 'common/components/animated_button';
import Thumbnail from 'common/components/thumbnail';
import { MoneyInputField, TextAreaField, CheckBoxField } from 'common/components/form_fields';

/**
 * Tip entry modal.
 *
 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */

/* @TODO: make this dynamic based on the context. */
const RECOMMENDED_TIP = 20;
const MINIMUM_TIP = 20;
const DISCLAIMER = "I understand that by tipping this creative my credit card will be charged the total amount shown above.";

let Form = ({error, handleSubmit, submitting, submitFailed, onClose, fee, total}) => (
  <form onSubmit={handleSubmit}>
    <h3>Tip amount</h3>
    <p>
      How much should I tip? For projects like yours we recomment making <strong>
      a tip of <Money value={RECOMMENDED_TIP}/></strong>.
    </p>

    <fieldset>
      <div className="row">
        <div className="columns medium-8 small-16">
          <Field name="value" component={MoneyInputField}/>
          {fee > 0 && <span>+ <Money value={fee}/> crowdspring fee</span>}
          <div className="total">Total: <Money value={total}/></div>
        </div>
      </div>
    </fieldset>

    <fieldset>
      <Field name="comment" description="Optional Comment" component={TextAreaField} />

      <Field name="accepted_disclaimer" component={CheckBoxField} label={DISCLAIMER}/>
    </fieldset>

    <div className="modal-actions">
      <AnimatedButton processing={submitting} type="submit" label="Tip"
        processingLabel="Tipping..." errorMsg={error || submitFailed} successMsg="Done!"/>

      <button className="btn btn-text btn-block" onClick={onClose}>Cancel</button>
    </div>
  </form>
)

const validate = (values) => {
  const errors = {}

  if (!values.value || values.value < MINIMUM_TIP) {
    errors.value = `Minimum tip value is $${MINIMUM_TIP}`;
  }

  if (!values.accepted_disclaimer) {
    errors.accepted_disclaimer = "You must confirm that you understand"
  }

  return errors
}

Form = reduxForm({
  form: "TipModal",
  validate
})(Form);


export default class TipModal extends Component {
  constructor(props) {
    super(props);

    this.state = { done: false };

    this.handleDone = this.handleDone.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleDone() {
    this.setState({ done: false });
    this.props.onClose();
  }

  handleSubmit(formData) {
    const { tip, entry } = this.props;

    return tip(entry, formData)
      .then(() => this.setState({ done: true }))
      .catch(res => {
        throw new SubmissionError({ _error: 'Failed to tip entry. Please try again.' });
      });
  }

  render() {
    const { done } = this.state;
    const { onClose, entry } = this.props;

    if (!entry) {
      return null;
    }

    const revision = (entry.revisions || [])[0] || {};
    const thumbnails = revision.thumbnails || [];
    const isName = entry.entry_type === 'name';
    const thumbnailImage = isName? null : first(thumbnails);

    return (
      <ModalDialog modalOpen={true} dialogClasses="tip-modal"
        modalHeader={`Tip ${entry.author_username}`} closeAction={onClose}>

        {!done?
        <div>
          <div className="row">
            <div className="columns small-16 medium-8">
              <h3>You can tip { entry.author_username } for their work on your project.</h3>
              <p>With the "Tip Creative" feature, you can thank a creative for their work
                on your project even though you didn't choose their entry.</p>
            </div>
            <div className="columns small-16 medium-8">
              <Thumbnail className="tile entry-thumbnail" image={thumbnailImage}>
                { isName && <div className="revision-name">{revision.name}</div> }
              </Thumbnail>
            </div>
          </div>
          <Form {...this.props} onSubmit={this.handleSubmit} />
        </div>:
        <div className="done">
          <h3>
            <i className="fa fa-check-circle"/><br/>Tip Complete
          </h3>

          <p>Thank you for showing your appreciation for { entry.author_username }'s work.</p>

          <div className="modal-actions">
            <button className="btn btn-primary" onClick={this.handleDone}>Done</button>
          </div>
        </div>}

      </ModalDialog>
    );
  }
}

TipModal.propTypes = {
  entry: PropTypes.object,
  fee: PropTypes.number.isRequired,
  total: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired,
  tip: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./entries/components/tip_modal.jsx